<template>
  <div style="display: flex">
    <div style="font-weight: bold; font-size: 20px">
      <v-icon class="mr-3">mdi-picture-in-picture-top-right</v-icon>
      Frames
    </div>
    <v-spacer />
    <HelpButton mdxName="CanvasConfig" />
  </div>
  <v-divider class="mt-3" />
  <div
    class="config-page-body"
    style="height: calc(100% - 100px)">
    <div style="margin-top: 40px; margin-bottom: 20px">
      <div></div>
      <v-card-subtitle>Selected Frame</v-card-subtitle>
      <v-divider />
    </div>
    <div
      class="mr-2 mb-3"
      style="
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        margin-bottom: 20px !important;
        margin-right: 0px !important;
      ">
      <v-btn
        v-for="frame in frames_edit"
        :key="frame.id"
        class="mb-1 mr-2 frame-button"
        @click="selected = frame.id"
        :dark="selected == frame.id"
        variant="flat"
        :style="selected !== frame.id ? '' : 'color: white !important;'"
        :color="selected == frame.id ? frame.color + ')' : ''">
        <div
          v-if="selected !== frame.id"
          class="mr-2"
          :style="`
                border-radius: 50%;
                width: 12px;
                height: 12px;
                color: white !important;
                background: ${frame.color});`"></div>
        <div
          v-else
          class="mr-2"
          :style="`
                border-radius: 50%;
                width: 12px;
                height: 12px;
                background: white; opacity:0.7`"></div>
        {{ frame.name }}
      </v-btn>
    </div>
    <div style="margin-top: 40px; margin-bottom: 20px">
      <div></div>
      <v-card-subtitle>Frame Details</v-card-subtitle>
      <v-divider />
    </div>
    <div v-if="frames_display[selected]">
      <div class="d-flex">
        <v-text-field
          label="Frame ID"
          placeholder="A unique identifier for this Frame"
          filled
          dense
          hide-details="true"
          type="text"
          class="mr-2 mb-2"
          v-model="frames_display[selected].frame_id"></v-text-field>
        <v-text-field
          label="Frame Nickname"
          placeholder="A nickname for this Frame"
          filled
          dense
          hide-details="true"
          type="text"
          class="mb-2"
          v-model="frames_display[selected].nickname"></v-text-field>
        <!-- <v-checkbox
          label="Enabled"
          class="ml-2"
          v-model="deluge.frames[selected].enabled"></v-checkbox> -->
      </div>
    </div>
    <div style="margin-top: 40px; margin-bottom: 20px">
      <div></div>
      <v-card-subtitle>Position & Resolution</v-card-subtitle>
      <v-divider />
    </div>
    <div style="margin-top: 40px; margin-bottom: 20px">
      <v-divider />
    </div>
    <v-card
      v-if="!is_omni()"
      flat
      class="mb-3 pa-3">
      <v-card flat>
        <div
          class="mx-3"
          style="margin: 0px !important">
          <div style="display: flex">
            <v-text-field
              label="Canvas Width"
              placeholder="Total width of your Canvas in pixels"
              dense
              filled
              v-on:keyup.enter="canvas_update"
              type="number"
              class="mr-2"
              v-model.number="user_canvas_width"></v-text-field>
            <v-text-field
              label="Canvas Height"
              placeholder="Total height of your Canvas in pixels"
              v-on:keyup.enter="canvas_update"
              dense
              filled
              type="number"
              class="mr-2"
              v-model.number="user_canvas_height"></v-text-field>
          </div>
          <v-alert
            v-if="user_canvas_width * user_canvas_height > total_pixels"
            class="mb-3"
            variant="tonal"
            color="warning"
            icon="mdi-alert">
            <strong>
              Settings are invalid as resolution exceeds total pixels ({
              (total_pixels / 10000000).toFixed(2) } Mega Pixel) available to
              current license.
            </strong>
          </v-alert>
        </div>
      </v-card>
    </v-card>
    <div
      style="display: flex"
      v-if="frames_display[selected]">
      <v-text-field
        label="Frame Width"
        filled
        dense
        type="number"
        :rules="[rules.width]"
        class="mr-2"
        v-model.number="frames_display[selected].width"></v-text-field>
      <v-text-field
        label="Frame Height"
        filled
        dense
        type="number"
        class="mr-2"
        :rules="[rules.height]"
        v-model.number="frames_display[selected].height"></v-text-field>
      <v-text-field
        label="Frame Left Offset"
        filled
        dense
        :rules="[rules.left]"
        type="number"
        class="mr-2"
        v-model.number="frames_display[selected].left"></v-text-field>
      <v-text-field
        label="Frame Top Offset"
        type="number"
        filled
        dense
        :rules="[rules.top]"
        v-model.number="frames_display[selected].top"></v-text-field>
    </div>
    <div
      ref="canvasareaparent"
      style="display: flex; justify-content: center">
      <div
        :style="`
            background: #101010;
            aspect-ratio: ${canvas_width} / ${canvas_height};
            max-width: 90vh;
            user-select: none;
            overflow:hidden;
            border-radius: 5px;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            width: ${evenWidth}px;
          `"
        v-if="!force_refresh">
        <v-progress-circular
          :size="80"
          :width="9"
          color="primary"
          indeterminate></v-progress-circular>
      </div>
      <div
        ref="canvasarea"
        v-else
        :style="`
            background: #101010;
            aspect-ratio: ${canvas_width} / ${canvas_height};
            user-select: none;
              overflow:visible;
              max-width: 90vh;
            border-radius: 5px;
            position: relative;
            width: ${evenWidth}px;
          `">
        <div
          v-if="waitForSet"
          style="height: 100%; width: 100%">
          <VueDraggableResizable
            v-for="frame in frames_edit"
            :key="frame.id"
            :parent="true"
            @dragging="onDrag"
            @resizing="onResize"
            :min-width="50"
            :min-height="50"
            :resizable="selected == frame.id"
            :h="Number(frames_edit[frame.id]?.divheight) || 100"
            :w="Number(frames_edit[frame.id]?.divwidth) || 100"
            :y="Number(frames_edit[frame.id]?.divtop) || 0"
            :x="Number(frames_edit[frame.id]?.divleft) || 0"
            :draggable="selected == frame.id"
            class-name-handle="frameitem"
            style="position: absolute; touch-action: none"
            :z="selected === frame.id ? 20 : 10 + (5 - frame.id)">
            <div
              v-if="selected == frame.id"
              :style="` background-color: ${frame.color}, 0.7); border-color: ${frame.color},1);`"
              class="resizable-content pa-2"
              style="
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                user-select: none;
              ">
              <div
                class="ma-1"
                style="overflow: hidden; opacity: 1; font-weight: bold">
                <v-icon
                  size="large"
                  color="white">
                  {{ `mdi-numeric-${frame.number}-box` }}
                </v-icon>
              </div>
            </div>
            <div
              v-else
              @click="selected = frame.id"
              :style="` background-color: ${frame.color}, 0.5); border-color: ${frame.color}, 0.4);`"
              class="resizable-content pa-2"
              style="
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                user-select: none;
              ">
              <div
                class="ma-1"
                style="overflow: hidden; opacity: 0.3">
                <v-icon
                  size="large"
                  color="white">
                  {{ `mdi-numeric-${frame.number}-box` }} {{ selected }}
                </v-icon>
              </div>
            </div>
          </VueDraggableResizable>
        </div>
      </div>
    </div>

    <div v-if="false">
      <v-alert
        v-if="deluge.frames[selected]?.channel_id"
        class="my-3"
        variant="tonal"
        color="warning"
        icon="mdi-alert">
        <strong>
          This Frame has a channel assigned to it, position/size changes may
          affect the output.
        </strong>
      </v-alert>
    </div>
  </div>
  <v-divider
    class="mt-3"
    style="margin-bottom: 12px !important" />
  <div style="display: flex">
    <v-spacer />

    <v-btn
      @click="update_frames"
      :loading="update_frames_loading"
      color="primary"
      variant="flat">
      <v-icon class="ml-1 mr-2">mdi-content-save</v-icon>
      Save
    </v-btn>
  </div>
</template>
<script setup>
import { deluge } from '@/stores/deluge.js';
import {
  onMounted,
  ref,
  onBeforeUnmount,
  watch,
  reactive,
  nextTick,
} from 'vue';
import { $http } from '../../stores/http.js';
import HelpButton from '../Help-Hints/HelpButton.vue';
import VueDraggableResizable from 'vue-draggable-resizable';

const emit = defineEmits(['close']);

const canvas_height = ref(1080);
const canvas_width = ref(1920);
const selected = ref(1);
const total_pixels = ref(0);
const user_canvas_height = ref(0);
const user_canvas_width = ref(0);
const force_refresh = ref(true);
const frames_edit = reactive({});
const frames_display = reactive({});
const update_frames_loading = ref(false);
var frame_window_resize = false;
const canvasarea = ref(null);
const canvasareaparent = ref(null);
const evenWidth = ref(0);
const waitForSet = ref(false);
let resizeObserver = null;
const simple_rules = {
  left: (left_amount, frame) => {
    if (isNaN(left_amount) || left_amount === null || left_amount === '')
      return 'Offset is required';
    return (
      left_amount + frames_edit[frame].width - 1 < canvas_width.value ||
      'Frame outside of Canvas (Left Offset)'
    );
  },
  top: (top_amount, frame) => {
    if (isNaN(top_amount) || top_amount === null || top_amount === '')
      return 'Offset is required';
    return (
      top_amount + frames_edit[frame].height - 1 < canvas_height.value ||
      'Frame outside of Canvas (Top Offset)'
    );
  },
  width: (width_amount, frame) => {
    if (
      isNaN(width_amount) ||
      width_amount === null ||
      width_amount === '' ||
      width_amount < 1
    )
      return 'Width must be at least 1';
    return (
      width_amount + frames_edit[frame].left - 1 < canvas_width.value ||
      'Frame outside of Canvas (Width)'
    );
  },
  height: (height_amount, frame) => {
    if (
      isNaN(height_amount) ||
      height_amount === null ||
      height_amount === '' ||
      height_amount < 1
    )
      return 'Height must be at least 1';
    return (
      height_amount + frames_edit[frame].top - 1 < canvas_height.value ||
      'Frame outside of Canvas (Height)'
    );
  },
};
const rules = {
  left: (left_amount) => {
    if (isNaN(left_amount) || left_amount === null || left_amount === '')
      return 'Offset is required (use 0 for no offset)';
    if (left_amount < 0) return 'Offset cannot be negative';
    return (
      left_amount + frames_edit[selected.value].width - 1 <
        canvas_width.value || 'Frame outside of Canvas (Left Offset)'
    );
  },
  top: (top_amount) => {
    if (isNaN(top_amount) || top_amount === null || top_amount === '')
      return 'Offset is required (use 0 for no offset)';
    if (top_amount < 0) return 'Offset cannot be negative';
    return (
      top_amount + frames_edit[selected.value].height - 1 <
        canvas_height.value || 'Frame outside of Canvas (Top Offset)'
    );
  },
  width: (width_amount) => {
    if (
      isNaN(width_amount) ||
      width_amount === null ||
      width_amount === '' ||
      width_amount < 1
    )
      return 'Width must be at least 1';
    return (
      width_amount + frames_edit[selected.value].left - 1 <
        canvas_width.value || 'Frame outside of Canvas (Width)'
    );
  },
  height: (height_amount) => {
    if (
      isNaN(height_amount) ||
      height_amount === null ||
      height_amount === '' ||
      height_amount < 1
    )
      return 'Height must be at least 1';
    return (
      height_amount + frames_edit[selected.value].top - 1 <
        canvas_height.value || 'Frame outside of Canvas (Height)'
    );
  },
};
const timerTask = ref(undefined);
watch(
  () => deluge.config.canvas,
  (newVal, oldVal) => {
    if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
      canvas_width.value = deluge.config.canvas.x;
      canvas_height.value = deluge.config.canvas.y;
      user_canvas_width.value = deluge.config.canvas.x;
      user_canvas_height.value = deluge.config.canvas.y;
      total_pixels.value = deluge.config.canvas_px_size;
      startLoadingState();
    }
  }
);

// Debounce timer for canvas dimension changes
let canvasResizeTimeout = null;

// When the user edits the canvas dimensions locally, update the preview.
// Uses a 2-second debounce so the user can finish typing before frames reposition.
watch(
  () => [user_canvas_width.value, user_canvas_height.value],
  (newVal, oldVal) => {
    // Clear any pending resize
    if (canvasResizeTimeout) {
      clearTimeout(canvasResizeTimeout);
    }

    // Update canvas dimensions immediately for the visual preview aspect ratio
    if (user_canvas_width.value && user_canvas_height.value) {
      canvas_width.value = user_canvas_width.value;
      canvas_height.value = user_canvas_height.value;
    }

    // Debounce the frame clamping and full refresh - wait 2 seconds after last keystroke
    canvasResizeTimeout = setTimeout(async () => {
      if (user_canvas_width.value && user_canvas_height.value) {
        // Auto-reposition frames to fit within new canvas bounds
        clampFramesToCanvas();

        // NOTE: We do NOT call startLoadingState() here because it calls setdata()
        // which would overwrite our clamped values with the original server data.
        // Instead, just trigger Vue to re-render by waiting a tick.
        await nextTick();

        // Force the draggable component to refresh by toggling waitForSet
        waitForSet.value = false;
        await nextTick();
        waitForSet.value = true;
      }
    }, 2000); // 2 second debounce
  }
);

// Clamp all frames to fit within the current canvas dimensions.
// This mirrors the backend logic in frames.py update_frames().
// Called when user edits canvas dimensions to keep frames visible in preview.
function clampFramesToCanvas() {
  for (const id in frames_edit) {
    const frame = frames_edit[id];
    const display = frames_display[id];

    if (!frame || !display) {
      continue;
    }

    // Clamp width/height first if they exceed canvas size
    if (frame.width > canvas_width.value) {
      frame.width = canvas_width.value;
      display.width = canvas_width.value;
    }
    if (frame.height > canvas_height.value) {
      frame.height = canvas_height.value;
      display.height = canvas_height.value;
    }

    // Calculate max allowed positions (frame must fit entirely within canvas)
    const maxLeft = canvas_width.value - frame.width;
    const maxTop = canvas_height.value - frame.height;

    // Clamp left/top to valid range
    if (frame.left < 0) {
      frame.left = 0;
      display.left = 0;
    } else if (frame.left > maxLeft) {
      frame.left = Math.max(0, maxLeft);
      display.left = Math.max(0, maxLeft);
    }

    if (frame.top < 0) {
      frame.top = 0;
      display.top = 0;
    } else if (frame.top > maxTop) {
      frame.top = Math.max(0, maxTop);
      display.top = Math.max(0, maxTop);
    }

    // Update div positions for visual preview
    frame.divwidth = Math.round(frame.width * calc_multiplier());
    frame.divheight = Math.round(frame.height * calc_multiplier(true));
    frame.divleft = Math.round(frame.left * calc_multiplier());
    frame.divtop = Math.round(frame.top * calc_multiplier(true));
  }
}
watch(frames_display, (newVal, oldVal) => {
  manualResize();
});
async function startLoadingState() {
  waitForSet.value = false;
  frame_window_resize = true;
  force_refresh.value = false;
  // If a refresh is already scheduled, don't reschedule — prevents perpetual restarts
  if (timerTask.value) {
    return;
  }
  // debounce and wait for layout to stabilise, then refresh the preview
  timerTask.value = setTimeout(async () => {
    frame_window_resize = false;
    if (frame_window_resize === false) {
      // ensure layout is ready (tries to wait for DOM measurement)
      const ok = await ensureLayoutReady();
      if (!ok) {
        // fallback short pause
        await new Promise((r) => setTimeout(r, 200));
      }
      force_refresh.value = true;
      await nextTick();
      setdata();
    }
    // clear the scheduled marker
    clearTimeout(timerTask.value);
    timerTask.value = undefined;
  }, 150);
}
// Store resize listener ref at top-level so it can be cleaned up
let resizeListener = null;

// Register cleanup hook BEFORE any async operations
onBeforeUnmount(() => {
  if (resizeListener) {
    window.removeEventListener('resize', resizeListener);
  }
  if (timerTask.value) clearTimeout(timerTask.value);
  if (resizeObserver) {
    try {
      resizeObserver.disconnect();
    } catch (e) {}
    resizeObserver = null;
  }
});

onMounted(async () => {
  // Wait a tick to ensure DOM refs are set, then measure
  await nextTick();
  // Safely read parent width (guard against null refs during mount/race conditions)
  const parentWidth =
    canvasareaparent.value?.getBoundingClientRect()?.width ?? 0;
  evenWidth.value = Math.floor(parentWidth / 100) * 100;
  canvas_width.value = deluge.config.canvas.x;
  canvas_height.value = deluge.config.canvas.y;
  user_canvas_width.value = deluge.config.canvas.x;
  user_canvas_height.value = deluge.config.canvas.y;
  total_pixels.value = deluge.config.canvas_px_size;

  // Measure layout and populate frames only after canvas area is ready
  await ensureLayoutReady();
  setdata();

  // Use a named listener so we can remove it on unmount
  resizeListener = () => {
    const w = canvasareaparent.value?.getBoundingClientRect()?.width ?? 0;
    evenWidth.value = Math.floor(w / 100) * 100;
    startLoadingState();
  };
  window.addEventListener('resize', resizeListener, { passive: true });

  // ResizeObserver: fires when the parent container becomes visible or changes size
  try {
    resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const w =
          entry.contentRect?.width ||
          canvasareaparent.value?.getBoundingClientRect().width;
        if (w && w > 10) {
          const newEven = Math.floor(w / 100) * 100;
          // only react if the computed even width changed (prevents frequent restarts)
          if (newEven !== evenWidth.value) {
            evenWidth.value = newEven;
            // trigger the same refresh flow as window resize
            startLoadingState();
          }
        }
      }
    });
    if (canvasareaparent.value) resizeObserver.observe(canvasareaparent.value);
  } catch (e) {
    // ResizeObserver may not be available in some environments; ignore and rely on window resize
  }

  startLoadingState();
});
function is_omni() {
  return deluge['canvaspro_core_info']['product_name'].toLowerCase() === 'omni';
}
// Wait for the canvas area to be measured (layout) before calculating sizes
async function ensureLayoutReady(retries = 10, delayMs = 16) {
  for (let i = 0; i < retries; i++) {
    await nextTick();
    // yield one animation frame to let layout occur
    await new Promise((r) => requestAnimationFrame(r));
    const rect = canvasarea.value?.getBoundingClientRect();
    if (rect && rect.width > 20 && rect.height > 20) return true;
    // small fallback delay
    await new Promise((r) => setTimeout(r, delayMs));
  }
  return false;
}

function calc_multiplier(top = false) {
  // Return safe multiplier even if DOM isn't ready yet
  const rect = canvasarea.value?.getBoundingClientRect();
  if (!rect || !canvas_width.value || !canvas_height.value) {
    return 1;
  }
  if (!top) {
    return Math.max(
      0.0001,
      Math.round(rect.width) / Math.round(canvas_width.value)
    );
  } else {
    return Math.max(
      0.0001,
      Math.round(rect.height) / Math.round(canvas_height.value)
    );
  }
}
function setdata() {
  var temp_frames = {};
  for (const id in deluge.frames) {
    temp_frames[id] = {};
    temp_frames[id].name = deluge.frames[id].name;
    temp_frames[id].frame_id = deluge.frames[id].frame_id;
    temp_frames[id].nickname = deluge.frames[id].nickname;
    temp_frames[id].id = deluge.frames[id].id;
    temp_frames[id].number = deluge.frames[id].number;
    temp_frames[id].width = deluge.frames[id].width;
    temp_frames[id].height = deluge.frames[id].height;
    temp_frames[id].left = deluge.frames[id].left;
    temp_frames[id].top = deluge.frames[id].top;
    temp_frames[id].divwidth = Math.round(
      deluge.frames[id].width * calc_multiplier()
    );
    temp_frames[id].divheight = Math.round(
      deluge.frames[id].height * calc_multiplier(true)
    );
    temp_frames[id].divleft = Math.round(
      deluge.frames[id].left * calc_multiplier()
    );
    temp_frames[id].divtop = Math.round(
      deluge.frames[id].top * calc_multiplier(true)
    );
    temp_frames[id].did = deluge.frames[id].did;
    temp_frames[id].channel_id = deluge.frames[id].channel_id;
    temp_frames[id].color = deluge.frames[id].color;
  }
  Object.assign(frames_edit, temp_frames);
  Object.assign(frames_display, temp_frames);
  waitForSet.value = true;
}
function checkRules() {
  for (const id in deluge.frames) {
    if (simple_rules.left(frames_edit[id].left, id) !== true) {
      return false;
    }
    if (simple_rules.top(frames_edit[id].top, id) !== true) {
      return false;
    }
    if (simple_rules.width(frames_edit[id].width, id) !== true) {
      return false;
    }
    if (simple_rules.height(frames_edit[id].height, id) !== true) {
      return false;
    }
  }
  return true;
}
function manualResize() {
  frames_edit[selected.value].width = frames_display[selected.value].width;
  frames_edit[selected.value].height = frames_display[selected.value].height;
  frames_edit[selected.value].left = frames_display[selected.value].left;
  frames_edit[selected.value].top = frames_display[selected.value].top;
  frames_edit[selected.value].divwidth = Math.round(
    frames_display[selected.value].width * calc_multiplier()
  );
  frames_edit[selected.value].divheight = Math.round(
    frames_display[selected.value].height * calc_multiplier(true)
  );
  frames_edit[selected.value].divleft = Math.round(
    frames_display[selected.value].left * calc_multiplier()
  );
  frames_edit[selected.value].divtop = Math.round(
    frames_display[selected.value].top * calc_multiplier(true)
  );
}
function onResize(x, y, width, height) {
  frames_edit[selected.value].left = x;
  frames_edit[selected.value].top = y;
  frames_edit[selected.value].width = width;
  frames_edit[selected.value].height = height;
  frames_display[selected.value].left = Math.round(x * (1 / calc_multiplier()));
  frames_display[selected.value].top = Math.round(
    y * (1 / calc_multiplier(true))
  );
  frames_display[selected.value].width = Math.round(
    width * (1 / calc_multiplier())
  );
  frames_display[selected.value].height = Math.round(
    height * (1 / calc_multiplier(true))
  );
}
function onDrag(x, y) {
  frames_edit[selected.value].left = x;
  frames_edit[selected.value].top = y;

  frames_display[selected.value].left = Math.round(x * (1 / calc_multiplier()));
  frames_display[selected.value].top = Math.round(
    y * (1 / calc_multiplier(true))
  );
}
// Helper to sanitize numeric values (handle NaN/empty strings)
function sanitizeNumber(value, fallback = 0, minValue = 0) {
  const num = Number(value);
  if (isNaN(num) || num < minValue) {
    return fallback;
  }
  return num;
}

async function update_frames() {
  if (checkRules()) {
    update_frames_loading.value = true;
    var frames = [];
    const values = Object.values(frames_edit);
    for (var i = 0; i < values.length; i++) {
      frames.push({
        left: sanitizeNumber(values[i].left, 0, 0),
        top: sanitizeNumber(values[i].top, 0, 0),
        height: sanitizeNumber(values[i].height, 100, 1),
        width: sanitizeNumber(values[i].width, 100, 1),
        id: values[i].id,
        frame_id: values[i].frame_id,
        nickname: values[i].nickname,
        enabled: deluge.frames[i + 1].enabled,
      });
    }
    await $http(
      'PUT',
      '/dynamic_engine/update_frames',
      JSON.stringify({
        canvas_height: user_canvas_height.value,
        canvas_width: user_canvas_width.value,
        frames: frames,
      })
    );
    update_frames_loading.value = false;
  } else {
    alert('Cannot save as a frame is outside of the Canvas area!');
  }
}

async function canvas_update() {
  try {
    await $http(
      'PUT',
      '/dynamic_engine/update_frames',
      JSON.stringify({
        canvas_height: user_canvas_height.value,
        canvas_width: user_canvas_width.value,
        frames: [],
      })
    );
    // Update local canvas dimensions and refresh preview immediately
    canvas_width.value = user_canvas_width.value;
    canvas_height.value = user_canvas_height.value;
    startLoadingState();
  } catch (e) {
    console.log(e);
  }
}
</script>
<style scoped>
@import './config.css';
</style>

<style>
@import 'vue-draggable-resizable/style.css';

.resizable-content {
  border-width: 2px;
  border-style: solid;
  height: 100%;
  width: 100%;
  cursor: grab;
  border-radius: 3px;
  box-sizing: border-box;
}
.resizable-content:active {
  cursor: grabbing;
}
.frameitem-tl {
  width: 12px !important;
  height: 12px !important;
  display: block !important;
  background: rgba(255, 255, 255, 0.74) !important;
  position: absolute !important;
  cursor: nw-resize;
  box-sizing: border-box;
  border-radius: 2px;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.6) !important;
}
.frameitem-tr {
  width: 12px !important;
  height: 12px !important;
  display: block !important;
  background: rgba(255, 255, 255, 0.74) !important;
  position: absolute;
  right: 0 !important;
  cursor: ne-resize;
  box-sizing: border-box;
  border-radius: 2px;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.6) !important;
}
.frameitem-br {
  width: 12px !important;
  height: 12px !important;
  display: block !important;
  background: rgba(255, 255, 255, 0.74) !important;
  position: absolute;
  bottom: 0 !important;
  right: 0 !important;
  cursor: se-resize;
  box-sizing: border-box;
  border-radius: 2px;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.6) !important;
}
.frameitem-bl {
  width: 12px !important;
  height: 12px !important;
  display: block !important;
  background: rgba(255, 255, 255, 0.74) !important;
  position: absolute !important;
  bottom: 0 !important;
  cursor: sw-resize;
  box-sizing: border-box;
  border-radius: 2px;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.6) !important;
}

.frame-button {
  margin-right: 5px !important;
  margin: 5px;
}

.frame-loading-wheel {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;
}
.canvasarea-container {
  width: 1000px;
}
@media screen and (max-width: 800px) {
  .canvasarea-container {
    width: 240px;
  }
}

@media screen and (max-width: 890px) and (min-width: 801px) {
  .canvasarea-container {
    width: 440px;
  }
}
@media screen and (max-width: 920px) and (min-width: 900px) {
  .canvasarea-container {
    width: 340px;
  }
}
@media screen and (max-width: 1100px) and (min-width: 921px) {
  .canvasarea-container {
    width: 440px;
  }
}
@media screen and (max-width: 1500px) and (min-width: 1101px) {
  .canvasarea-container {
    width: 560px;
  }
}
@media screen and (max-width: 1600px) and (min-width: 1501px) {
  .canvasarea-container {
    width: 640px;
  }
}
@media screen and (max-width: 1800px) and (min-width: 1601px) {
  .canvasarea-container {
    width: 840px;
  }
}
</style>
